/**
 * We changed the structure of the data for fragments, from:
 * {
 *     id
 *     type
 *     sig
 *     ...actual data
 * }
 * to:
 * {
 *     id
 *     type
 *     sig
 *     metadata
 *     value: {...actual data}
 * }
 * This requires changes in the DAL. For now, and do avoid later migration, we are just mapping the data from and to the server for fragments
 * Check other files from the same merge commits to see places affected
 */

import type {GetTransactionResponse} from '@wix/document-manager-extensions'
import type {GetTransactionsResponse, Transaction} from '@wix/document-manager-extensions/src/types'
import _ from 'lodash'

export function mapTransaction(transaction: Transaction): Transaction {
    return {
        ...transaction,
        actions: transaction.actions?.map((action: any) => {
            if (action.metadata) {
                const cleanAction = _.omit(action, ['metadata'])
                return {
                    ...cleanAction,
                    value: {
                        ...(action.value ?? {}),
                        metaData: action.metadata
                    }
                }
            }
            return action
        })
    }
}

export function mapTransactionResponse(transactionResponse: GetTransactionResponse): GetTransactionResponse {
    return {
        ...transactionResponse,
        transaction: mapTransaction(transactionResponse.transaction ?? {})
    }
}

export function mapTransactionsResponse(transactionsResponse: GetTransactionsResponse): GetTransactionsResponse {
    return {
        ...transactionsResponse,
        transactions: transactionsResponse.transactions?.map(mapTransaction)
    }
}
